<template>
  <span class="supportLoader" hidden></span>
  <div class="siteViewport"><router-view/></div>
</template>

<style>
@import './css/header.css';
@import './css/homepage.css';
@import './css/footer.css';
@import './css/trackingpage.css';
@import './css/style.css';
@import './css/partnerpage.css';
@import './css/optoutpage.css';

@font-face {
  font-family: 'Metropolis-Bold';
  src: url('./fonts/Metropolis-Bold.otf') format('opentype');
}

@font-face {
  font-family: 'Metropolis-Medium';
  src: url('./fonts/Metropolis-Medium.otf') format('opentype');
}

@font-face {
  font-family: 'Metropolis-Regular';
  src: url('./fonts/Metropolis-Regular.otf') format('opentype');
}

@font-face {
  font-family: 'Metropolis-Thin';
  src: url('./fonts/Metropolis-Thin.otf') format('opentype');
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
    margin: 0px;
    font-family: 'Metropolis-Regular';
    font-size: 18px;
    line-height: 28px;
    color: #000;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>

